import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FundamentCommonModule } from 'fundament/fundament-common.module';
import { FoundationModule } from '../foundation/foundation.module';
import { ButtonIconComponent } from './buttons/button-icon.component';
import { ButtonLoadingComponent } from './buttons/button-loading.component';
import { DangerButtonComponent } from './buttons/danger/danger-button.component';
import { FilledButtonComponent } from './buttons/filled/filled-button.component';
import { IconButtonComponent } from './buttons/icon/icon-button.component';
import { OutlinedButtonComponent } from './buttons/outlined/outlined-button.component';
import { TextButtonComponent } from './buttons/text/text-button.component';
import { PillGroupComponent } from './pill-group/pill-group.component';
import { SingleSelectPillComponent } from './single-select-pill/single-select-pill.component';

@NgModule({
  imports: [CommonModule, FundamentCommonModule, FoundationModule],
  declarations: [
    ButtonIconComponent,
    ButtonLoadingComponent,
    DangerButtonComponent,
    FilledButtonComponent,
    IconButtonComponent,
    OutlinedButtonComponent,
    PillGroupComponent,
    SingleSelectPillComponent,
    TextButtonComponent,
  ],
  exports: [
    DangerButtonComponent,
    FilledButtonComponent,
    IconButtonComponent,
    OutlinedButtonComponent,
    PillGroupComponent,
    SingleSelectPillComponent,
    TextButtonComponent,
  ],
  providers: [],
})
export class ActionsModule {}
